import modal from "./modal";
import download from "./download";

export default {
    install(Vue) {
        // 模态框对象
        Vue.prototype.$modal = modal;
        Vue.prototype.$download = download;
    }
};
